<template>
    <BInput
        v-model="localValue"
        class="ls-top-level-search-input"
        placeholder="Search by Name / Address / Email / Phone"
        icon="magnify"
        type="search"
        test-id="ls-top-level-search-input"
        @keyup.native.enter="onEnter"
    />
</template>

<script>
import VueTypes from 'vue-types';

export default {
    name: 'LsTopLevelSearchInput',
    props: {
        value: VueTypes.string.isRequired,
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
    methods: {
        onEnter() {
            this.$emit('enter');
        },
    },
};
</script>

<style lang="scss">
.ls-top-level-search-input {
    .input {
        border-width: 0 0 1px 0;
        background-color: transparent;
        box-shadow: none;
        border-color: $gray-primary;
        font-size: $size-4;
    }

    .input::-webkit-search-cancel-button {
        -webkit-appearance: none;
        content: url(assets/cancel.svg);
        transform: rotate(45deg);
    }

    .mdi-magnify::after {
        content: url(assets/magnify.svg);
        position: absolute;
        top: 7px;
        left: 7px;
    }
}
</style>
